import s from "./schedulingTerm.module.css";
import {purpleAlertIcon} from "../../../../../../../assets";
import {h} from "preact";
import {useUserContext} from "../../../../../../../contexts";

const SchedulingTerm = () => {
    const [{}, {}, {}, {
        schedulingTerm
    }] = useUserContext();

    return (
        <div className={`${s.root}`}>
            <img
                src={purpleAlertIcon}
                alt=""
            />
            <p>
                Para atendimento móvel, entraremos em contato dentro de até
                <span>
                    &nbsp;{schedulingTerm || "72 horas"}&nbsp;
                </span>
                para confirmar seus dados e
                agendar o seu atendimento.
            </p>
        </div>
    )
}

export default SchedulingTerm;
